// src/data/RevisedProjectData.js

const data = [
  {
    project_name: "World Store",
    monthly_budget: 120000,
    planned_daily_spend: 4000,
    remaining_budget_for_the_month: 40000,
    Revised_Daily_spend: 3077,
    costs: 80000,
    impressions: 3891211,
    clicks: 778242,
    ctr: "20%",
    conversions: 1900,
    CPL: 42,
    agency_fees: 18000,
    Tasks: "View Tasks",
    customer_id: "4643036315",
    project_id: "112",
    currency: "INR",
    platform: "google_ads",
    ad_account_id:"25"

  },
  {
    project_name: "HP Healthcare",
    monthly_budget: 200000,
    planned_daily_spend: 6667,
    remaining_budget_for_the_month: 131000,
    Revised_Daily_spend: 10077,
    costs: 69000,
    impressions: 99226,
    clicks: 11907,
    ctr: "12%",
    conversions: 788,
    CPL: 88,
    agency_fees: 30000,
    Tasks: "View Tasks",
    customer_id: "1176825945",
    project_id: "22",
    currency: "USD",
    platform: "google_ads",
    ad_account_id:"9"
  },
  {
    project_name: "Global Watches",
    monthly_budget: 90000,
    planned_daily_spend: 3000,
    remaining_budget_for_the_month: 50000,
    Revised_Daily_spend: 3846,
    costs: 40000,
    impressions: 466945,
    clicks: 107397,
    ctr: "23%",
    conversions: 2850,
    CPL: 14,
    agency_fees: 13500,
    Tasks: "View Tasks",
    customer_id: "4643036315",
    project_id: "116",
    currency: "INR",
    platform: "google_ads",
    ad_account_id:"25"

  },
  {
    project_name: "Crestpoint Solutions",
    monthly_budget: 240000,
    planned_daily_spend: 8000,
    remaining_budget_for_the_month: 11000,
    Revised_Daily_spend: 846,
    costs: 229000,
    impressions: 739330,
    clicks: 144687,
    ctr: "19.57%",
    conversions: 1123,
    CPL: 204,
    agency_fees: 36000,
    Tasks: "View Tasks",
    customer_id: "7948821642",
    project_id: "23",
    currency: "USD",
    platform: "google_ads",
    ad_account_id:"10"

  },
  {
    project_name: "American Tech Inc",
    monthly_budget: 220000,
    planned_daily_spend: 7333,
    remaining_budget_for_the_month: 12000,
    remaining_budget: 32000,
    Revised_Daily_spend: 2462,
    costs: 188000,
    impressions: 661506,
    clicks: 164053,
    ctr: "24.80%",
    conversions: 1490,
    CPL: 126,
    agency_fees: 33000,
    Tasks: "View Tasks",
    customer_id: "4643036315",
    project_id: "120",
    currency: "USD",
    platform: "google_ads",
    ad_account_id:"25"

  },
  {
    project_name: "AVP Solutions",
    monthly_budget: 230000,
    planned_daily_spend: 7667,
    remaining_budget_for_the_month: 121000,
    Revised_Daily_spend: 9308,
    costs: 109000,
    impressions: 894979,
    clicks: 80548,
    ctr: "9%",
    conversions: 8912,
    CPL: 12,
    agency_fees: 34500,
    Tasks: "View Tasks",
    customer_id: "4643036315",
    project_id: "120",
    currency: "INR",
    platform: "microsoft_ads",
    ad_account_id:"25"

  },
];

export default data;
